var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDocs(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8zm10.238.867l1.803-4.508a.308.308 0 00-.4-.4L7.133 5.762a2.462 2.462 0 00-1.371 1.371l-1.803 4.508a.307.307 0 00.4.4l4.508-1.803a2.462 2.462 0 001.371-1.371zM8.923 8a.923.923 0 11-1.846 0 .923.923 0 011.846 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDocs);
export default "/_next/static/images/2549ecbee38c960d9c50f80ffc865198.svg";
export { ForwardRef as ReactComponent };